<template>
  <div class="sidebar-logo-container">
    <transition name="sidebarLogoFade">
      <router-link :class="['sidebar-logo-link flex-c-s', collapse ? 'collapse' : '']" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <h1 v-if="title" class="sidebar-title">{{ title }} </h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Logo",
  props: {
    collapse: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    logo() {
      return this.$store.state.setting.logo 
    },
    title() {
      return this.$store.state.setting.title
    },
    showHeader() {
      return this.$store.state.setting.showHeader
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: $LayoutHeaderHeight;
  line-height: $LayoutHeaderHeight;
  background: #008CFF;
  text-align: center;

  .sidebar-logo-link {
    height: 100%;
    width: 100%;
    text-align: left;
    padding-left: 10px;
    &.collapse{
      .sidebar-logo {
        margin-left: 0;
      }
      .sidebar-title {
        display: none;
      }
    }

    .sidebar-logo {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      vertical-align: middle;
      margin-right: 8px;
    }

    .sidebar-title {
      display: inline-block;
      margin: 0;
      overflow: hidden;
      color: #fff;
      font-weight: 600;
      line-height: $LayoutHeaderHeight;
      vertical-align: middle;
      font-size: 24px;
    }
  }
}
</style>
